export default "__VITE_ASSET__EC4lncLp__"